<template>
	<div class="intellectual-home">
		
		<!-- 导航栏 -->
		<div class="intellectual-home.nav">
			<div class="intellectual-home.block">
				<intellectual-navigation :isTrademark="isTrademark" @toggleTrademarks="toggleTrademarks"></intellectual-navigation>
			</div>
		</div>
		<!-- banner -->
		<div class="intellectual-home.banner" data-aos="fade-right">
			<banner-form @showTipsEvent="showTipsEvent"></banner-form>
		</div>
		<!-- 全部商标分类  -->
		<div class="intellectual-home.block">
			<all-trademarks></all-trademarks>
		</div>
		<!-- 日化用品 -->
		<div class="intellectual-home.block">
			<common-cards :data="supplies"></common-cards>
		</div>
		<!-- 医药商标 -->
		<div class="intellectual-home.block">
			<common-cards :data="medicine"></common-cards>
		</div>
		<!-- 电子产品 -->
		<div class="intellectual-home.block">
			<common-cards :data="electronic"></common-cards>
		</div>
		<!-- 服装鞋帽 -->
		<div class="intellectual-home.block">
			<common-cards :data="clothing"></common-cards>
		</div>
		<!-- 食品商标 -->
		<div class="intellectual-home.block">
			<common-cards :data="food"></common-cards>
		</div>
		<!-- 酒商标 -->
		<div class="intellectual-home.block">
			<common-cards :data="liqueur"></common-cards>
		</div>
		<!-- 广告销售 -->
		<div class="intellectual-home.block">
			<common-cards :data="ads"></common-cards>
		</div>
		
		<!-- 餐饮住宿 -->
		<div class="intellectual-home.block">
			<common-cards :data="accommodation"></common-cards>
		</div>
		<!-- footer -->
		<common-footer></common-footer>
		<tips-modal :tipsShow="tipsShow" @closeTipsEvent="closeTipsEvent"></tips-modal>
	</div>
</template>
<script>
	import IntellectualHeader from '../components/intellectual-header.vue'
	import IntellectualNavigation from '../components/intellectual-navigation.vue'
	import BannerForm from '../components/banner-form.vue'
	import AllTrademarks from '../components/all-trademarks.vue'
	import CommonCards from '../components/common-cards.vue'
	import CommonFooter from "../components/common-footer.vue"
	import TipsModal from '../components/tips-modal.vue'
	export default {
		components: {
			IntellectualHeader,
			IntellectualNavigation,
			BannerForm,
			AllTrademarks,
			CommonCards,
			CommonFooter,
			TipsModal

		},
		data(){
			return{
				isTrademark:true,
				tipsShow:false,
				supplies:{
					title:'03类-日化用品',
					desc:'Daily chemicals',
					headBg:require('../assets/cards/card-1.png'),
					headIcon:require('../assets/cards/card-1-icon.png'),
					triangle:require('../assets/cards/cards-1-triangle.png'),
					triangleDown:require('../assets/cards/cards-1-triangle-down.png'),
					borderColor:'rgba(246,73,70,1)',
					id:18
				},
				medicine:{
					title:'05类-医药',
					desc:'Medical trademark',
					headBg:require('../assets/cards/card-2.png'),
					headIcon:require('../assets/cards/card-2-icon.png'),
					triangle:require('../assets/cards/cards-2-triangle.png'),
					triangleDown:require('../assets/cards/cards-2-triangle-down.png'),
					borderColor:'#13A6EC',
					id:20
				},
				electronic:{
					title:'09类-科学仪器',
					desc:'Electronic product',
					headBg:require('../assets/cards/card-3.png'),
					headIcon:require('../assets/cards/card-3-icon.png'),
					triangle:require('../assets/cards/cards-3-triangle.png'),
					triangleDown:require('../assets/cards/cards-3-triangle-down.png'),
					borderColor:'#9F67D8',
					id:24
				},
				clothing:{
					title:'25类-服装鞋帽',
					desc:'Clothing  and  shoes',
					headBg:require('../assets/cards/card-4.png'),
					headIcon:require('../assets/cards/card-4-icon.png'),
					triangle:require('../assets/cards/cards-4-triangle.png'),
					triangleDown:require('../assets/cards/cards-4-triangle-down.png'),
					borderColor:'#EE8C18',
					id:40
				},
				food:{
					title:'29类-食品',
					desc:'Food trademark',
					headBg:require('../assets/cards/card-5.png'),
					headIcon:require('../assets/cards/card-5-icon.png'),
					triangle:require('../assets/cards/cards-5-triangle.png'),
					triangleDown:require('../assets/cards/cards-5-triangle-down.png'),
					borderColor:'#68AA04',
					id:44
				},
				liqueur:{
					title:'33类-酒',
					desc:'Liquor trademark',
					headBg:require('../assets/cards/card-7.png'),
					headIcon:require('../assets/cards/card-7-icon.png'),
					triangle:require('../assets/cards/cards-7-triangle.png'),
					triangleDown:require('../assets/cards/cards-7-triangle-down.png'),
					borderColor:'#C939C4',
					id:48
				},
				ads:{
					title:'35类-广告销售',
					desc:'Advertising sales',
					headBg:require('../assets/cards/card-6.png'),
					headIcon:require('../assets/cards/card-6-icon.png'),
					triangle:require('../assets/cards/cards-6-triangle.png'),
					triangleDown:require('../assets/cards/cards-6-triangle-down.png'),
					borderColor:'#3593E7',
					id:50
				},
				accommodation:{
					title:'43类-餐饮住宿',
					desc:'Catering accommodation',
					headBg:require('../assets/cards/card-8.png'),
					headIcon:require('../assets/cards/card-8-icon.png'),
					triangle:require('../assets/cards/cards-8-triangle.png'),
					triangleDown:require('../assets/cards/cards-8-triangle-down.png'),
					borderColor:'#06B3B6',
					id:58
				},
			}
		},
		methods:{
			closeTipsEvent(val) {
				this.tipsShow = val
			},
			showTipsEvent(val){
				this.tipsShow = val
			},
			toggleTrademarks(val){
				this.isTrademark = val
			}
		}
	
	}
</script>
<style lang="scss">
	@include component(intellectual-home) {
		@include part(block) {
			width: $minWidth;
			padding: 0 25px;
			margin: 0 auto;
			
		}
		@include part(nav){
			background: #fff;
		}

		@include part(banner) {
			width: 100%;
			min-width: $minWidth;
			height: 520px;
			background-image: url(../assets/banner/banner-copy.jpg);
			background-size: cover;


		}
	}
</style>
